import hematramYadav from "../../assets/Pannel Members/hematram.jpg";
import ramanPreet from "../../assets/Pannel Members/raman.jpg";
import axelKaehne from "../../assets/Pannel Members/axel.jpg";
import julietNyasulu from "../../assets/Pannel Members/juliet.jpg";
import judilynnSolidum from "../../assets/Pannel Members/judilynn.jpg";
import gilmoreSolidum from "../../assets/Pannel Members/gilmore.jpg";
import billyJayPedron from "../../assets/Pannel Members/billy.jpg";
import haritAgroia from "../../assets/Pannel Members/harit.jpg";
import bJyothi from "../../assets/Pannel Members/jyothi.png";


import hematramYadav_banner from "../../assets/Pannel Banners/hematram_banner.jpg";
import ramanPreet_banner from "../../assets/Pannel Banners/raman_banner.jpg";
import axelKaehne_banner from "../../assets/Pannel Banners/axel_banner.jpg";
import julietNyasulu_banner from "../../assets/Pannel Banners/juliet_banner.jpg";
import judilynnSolidum_banner from "../../assets/Pannel Banners/judilynn_banner.jpg";
import gilmoreSolidum_banner from "../../assets/Pannel Banners/gilmore_banner.jpg";
import billyJayPedron_banner from "../../assets/Pannel Banners/billy_banner.jpg";
import haritAgroia_banner from "../../assets/Pannel Banners/harit_banner.jpg";
import bJyothi_banner from "../../assets/Pannel Banners/india.jfif";

export const panel_members_about = [
  {
    id: "harit-agroia",
    image: haritAgroia,
    name: "Dr. Harit Agroia",
    from: "San Jose State University, USA",
    about: "",
    link: "/executive-panel-members/harit-agroia",
  },
  {
    id: "axel-kaehne",
    image: axelKaehne,
    name: "Dr. Axel Kaehne",
    from: "Edge Hill University, UK",
    about: "",
    link: "/executive-panel-members/axel-kaehne",
  },
  {
    id: "raman-preet",
    image: ramanPreet,
    name: "Dr. Raman Preet",
    from: "Umeå University, Sweden",
    about: "",
    link: "/executive-panel-members/raman-preet",
  },
  {
    id: "hematram-yadav",
    image: hematramYadav,
    name: "Prof. Dr. Hematram Yadav",
    from: "MAHSA University, Malaysia",
    about: "",
    link: "/executive-panel-members/hematram-yadav",
  },
  {
    id: "juliet-nyasulu",
    image: julietNyasulu,
    name: "Dr. Juliet Nyasulu",
    from: "Stellenbosch University, South Africa",
    about: "",
    link: "/executive-panel-members/juliet-nyasulu",
  },
  {
    id: "judilynn-solidum",
    image: judilynnSolidum,
    name: "Dr. Judilynn L. Niedo-Solidum",
    from: "University of the Philippines Manila",
    about: "",
    link: "/executive-panel-members/judilynn-solidum",
  },
  {
    id: "gilmore-solidum",
    image: gilmoreSolidum,
    name: "Prof. Dr. Gilmore G. Solidum",
    from: "PLM College of Nursing, Philippines",
    about: "",
    link: "/executive-panel-members/gilmore-solidum",
  },
  {
    id: "billy-jay-pedron",
    image: billyJayPedron,
    name: "Dr. Billy Jay Pedron",
    from: "De La Salle Medical and Health Sciences Institute, Philippines",
    about: "",
    link: "/executive-panel-members/billy-jay-pedron",
  },
  {
    id: "harit-agroia",
    image: haritAgroia,
    name: "Dr. Harit Agroia",
    from: "San Jose State University, USA",
    about: "",
    link: "/executive-panel-members/harit-agroia",
  },
  {
    id: "b-jyothi",
    image: bJyothi,
    name: "Dr. B. Jyothi",
    from: "Govt. City College, Autonomous, Nayapul, Telangana, India",
    about: "",
    link: "/executive-panel-members/b-jyothi",
  },
];


export const panel_members = panel_members_about;

export const hematram_yadav_data = {
  image: hematramYadav,
  name: "Prof. Dr. Hematram Yadav",
  from: "",
  about:
    "Professor Dr. Hematram Yadav is former professor of Community Medicine at MAHSA University, Malaysia. He has held leadership roles in multiple Malaysian health institutions and served globally through WHO and UNICEF. With over 40 years of public health experience, he is renowned for his contributions to maternal and child health, health systems management, and public health conferences across the Western Pacific region.",
  banner: hematramYadav_banner,
  link: "/executive-panel-members/hematram-yadav",
};

export const raman_preet_data = {
  image: ramanPreet,
  name: "Dr. Raman Preet",
  from: "Umeå University, Sweden",
  about: "Dr. Raman Preet is a dental public health and global health expert, serving as Equal Opportunity Officer and senior research coordinator at Umeå University. She specializes in managing transnational health research projects funded by the EU and consults with WHO and NGOs on collaborative global health initiatives.",
  banner: ramanPreet_banner,
  link: "/executive-panel-members/raman-preet",
};

export const axel_kaehne_data = {
  image: axelKaehne,
  name: "Dr. Axel Kaehne",
  from: "Edge Hill University, UK", 
  about: "Dr. Axel Kaehne is Professor of Health Services Research at Edge Hill University, UK, and editor-in-chief of key healthcare journals. He evaluates national health programs in the UK and holds visiting professorships and advisory positions in multiple global healthcare organizations.",
  banner: axelKaehne_banner,
  link: "/executive-panel-members/axel-kaehne",
};

export const juliet_nyasulu_data = {
  image: julietNyasulu,
  name: "Dr. Juliet Nyasulu",
  from: "Stellenbosch University, South Africa",
  about: "With 25+ years of experience in African health systems, Dr. Juliet Nyasulu is a specialist in health system strengthening and quality assurance. She has contributed significantly to South Africa’s public health leadership and research at the University of Witwatersrand and Stellenbosch University.",
  banner: julietNyasulu_banner,
  link: "/executive-panel-members/juliet-nyasulu",
};

export const judilynn_solidum_data = {
  image: judilynnSolidum,
  name: "Dr. Judilynn L. Niedo-Solidum",
  from: "University of the Philippines Manila",
  about: "Dr. Judilynn Solidum is a professor and president of the UNIFFIED Manila Plus Chapter. Her credentials span pharmacy, environmental science, and strategic leadership. She is known for her contributions in pharmaceutical education and research ethics.",
  banner: judilynnSolidum_banner,
  link: "/executive-panel-members/judilynn-solidum",
};

export const gilmore_solidum_data = {
  image: gilmoreSolidum,
  name: "Prof. Dr. Gilmore G. Solidum",
  from: "PLM College of Nursing, Philippines",
  about: "Prof. Gilmore Solidum is a veteran academician and researcher in nursing, psychology, and healthcare management. With a PhD in Management and a commitment to lifelong learning, he serves as a senior leader in multiple professional and educational institutions.",
  banner: gilmoreSolidum_banner,
  link: "/executive-panel-members/gilmore-solidum",
};

export const billy_jay_pedron_data = {
  image: billyJayPedron,
  name: "Dr. Billy Jay Pedron",
  from: "De La Salle Medical and Health Sciences Institute, Philippines",
  about: "Dr. Pedron is a physical therapist and healthcare academic with expertise in health systems research, public health, and disability studies. He holds certifications in rehabilitation, education, and culinary arts, and is a Fellow of the Royal Institute of Healthcare, Singapore.",
  banner: billyJayPedron_banner,
  link: "/executive-panel-members/billy-jay-pedron",
};

export const harit_agroia_data = {
  image: haritAgroia,
  name: "Dr. Harit Agroia",
  from: "San Jose State University, USA",
  about: "With over 15 years in infectious disease and health behavior research, Dr. Harit Agroia holds a Doctorate in Public Health and advanced epidemiology certification from Johns Hopkins. She is a certified health education specialist and passionate about global disease prevention.",
  banner: haritAgroia_banner,
  link: "/executive-panel-members/harit-agroia",
};

export const b_jyothi_data = {
  image: bJyothi,
  name: "Dr. B. Jyothi",
  from: "Govt. City College, Autonomous, Nayapul, Telangana, India",
  about: "Dr. B. Jyothi is an Assistant Professor from Govt. City College, Autonomous, Nayapul, Telangana, India, with a distinguished academic journey in Organic Chemistry. She completed her B.Sc. in 2008 and M.Sc. in 2010. She earned the CSIR–JRF fellowship in 2010 itself. She was awarded her Ph.D. in 2023 from Osmania University. Over the years, she has guided students to success, winning JIGNASA STATE-LEVEL STUDENT PROJECT competitions TWICE securing 2nd prize in 2017-18 and 3rd prize in 2022-23 academic years with a cash prize of Rs. 21000 and Rs.18000 respectively, and has been recognized with the Outstanding Supervisor Award by the Commissioner of Collegiate Education, Telangana twice for the same. She also received the Inspirational Teacher Award from I2OR in 2025. She has 14 years of teaching experience. Her scholarly contributions include six international publications, two international book chapters, authorship of two textbooks, reflecting her commitment to advancing chemical sciences and education. Her specializing in Organic Chemistry with a strong research focus on computer aided drug design (CADD) and nanomaterials. Her work integrates computational chemistry and molecular modelling to accelerate the discovery of novel therapeutic agents, while simultaneously exploring nanomaterials as innovative platforms for drug delivery, diagnostics, and biomedical applications. By combining in silico drug design approaches with the unique physicochemical properties of nanostructures, she aims to develop more efficient, targeted, and sustainable solutions in pharmaceutical sciences. This interdisciplinary research not only bridges chemistry, biology, and computational sciences but also contributes to advancing personalized medicine and next generation healthcare technologies.",
  banner: bJyothi_banner,
  link: "/executive-panel-members/b-jyothi",
};


export const epms_details_map = {
    'hematram-yadav': hematram_yadav_data,
    'raman-preet': raman_preet_data,
    'axel-kaehne': axel_kaehne_data,
    'juliet-nyasulu': juliet_nyasulu_data,
    'judilynn-solidum': judilynn_solidum_data,
    'gilmore-solidum': gilmore_solidum_data,
    'billy-jay-pedron': billy_jay_pedron_data,
    'harit-agroia': harit_agroia_data,
    'b-jyothi': b_jyothi_data,
};